import { isMobile } from 'utils/getDevice'

export const useConditionals = () => {
	const modalErrorButtonText = isMobile() 
	? 'Tirar foto' 
	: 'Enviar foto'
	
	const modalErrorHasCloseButton = !isMobile()
	
	return {
		modalErrorButtonText,
		modalErrorHasCloseButton,
	}
}